import { AdminShell } from '@/features/admin/components/admin-shell.js';
import { AuditLogPage } from '@/features/admin/components/audit-log/audit-log-page.js';
import { useAuth } from '@/lib/auth/use-auth.js';
import { tokens } from '@/lib/tokens.js';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/audit-log')({
  component: AuditLogRoute,
});

function AuditLogRoute() {
  const { user } = useAuth();
  const tenantId = user?.tenant ?? '';

  return (
    <AdminShell currentPath="/audit-log">
      <div>
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: tokens.colors.textDark,
            marginBottom: '1.5rem',
          }}
        >
          Audit Log
        </h1>
        <AuditLogPage tenantId={tenantId} />
      </div>
    </AdminShell>
  );
}
